<template>
    <section>
        <b-row>
            <b-form-group class="col-md-3" :label="$t('global.filterByService')">
				<b-form-select placeholder="Todos" :options="optsRides" class="h-auto" v-model="filters.transportServiceId" ></b-form-select>
			</b-form-group>
			<b-form-group class="col-md-3" label=".">
				<b-button variant="outline-primary" @click="search">{{ $t('global.search') }}</b-button>
			</b-form-group>
        </b-row>
        <p class="text-danger text-sm" v-if="showAlertFilter">
            <small>
                <md-icon icon="warning" class="text-danger"/>
                {{ $t('global.filteringByService') }}
            </small>
        </p>

        <AjaxTable
            id="table-history"
            stacked="lg"
            :filters="filtersClean"
            :columns="modelColumns"
            resource="reservations/history"
            responsive>
            <template #cell(changeType)="row">
                <div>
                    {{ row.item.changeType }}
                    <b-badge variant="info" v-if="row.item.action == 'new'">{{ $t('global.new') }}</b-badge>
                    <b-badge variant="success" v-if="row.item.action == 'add'">{{ $t('global.add') }}</b-badge>
                    <b-badge variant="warning" v-if="row.item.action == 'edit'">{{ $t('global.edit') }}</b-badge>
                    <b-badge variant="danger" v-if="row.item.action == 'delete'">{{ $t('global.delete') }}</b-badge>
                </div>
            </template>
            <template #cell(change)="row">
                <div v-for="(log, index) in row.item.changes" :key="index"
                    class="">
                    [{{ $t('history.' + log.input) }}]:
                    <span class="text-muted"> {{ log.oldValue }} </span>
                    <small><md-icon icon="east"/></small>
                    {{ log.newValue }}
                </div>
                <!--
                <div class="bg-white">
                    <div class="bg-white table-responsive">
                        <table class="table table-sm table-hover pb-0 mb-0">
                            <tr>
                                <th class="bg-white">{{ $t('global.field') }}</th>
                                <th class="bg-white">{{ $t('global.before') }}</th>
                                <th class="bg-white">{{ $t('global.after') }}</th>
                            </tr>
                            <tbody>
                                <tr v-for="(log, index) in row.item.changes" :key="index">
                                    <td class="bg-white">{{ $t('history.' + log.input) }}</td>
                                    <td class="bg-white">{{ log.oldValue }}</td>
                                    <td class="bg-white">{{ log.newValue }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            -->
            </template>
        </AjaxTable>
    </section>
</template>
<script>
import AjaxTable from '@/components/helpers/AjaxTable.vue'
export default {
    components: {
		AjaxTable
	},
    props: {
        modelId: {
			type : Number,
			required: false,
			default:-1
        },
        model: Object
    },
    data() {
        return {
            showAlertFilter:false,
			loading:false,
			modelColumns : [
				{key:'id',label:this.$t('global.idChange')},
				{key:'creationDatetime',label:this.$t('global.date')},
				{key:'user',label:this.$t('global.user')},
				{key:'changeType',label:this.$t('global.changeType')},
				{key:'change',label:this.$t('global.changes')},
			],
			filters:{
				transportServiceId:""
			},
            changeFields: [
                {
                    key: 'input',
                    label: this.$t('global.field')
                },
                {
                    key: 'oldValue',
                    label: this.$t('global.before')
                },
                {
                    key: 'newValue',
                    label: this.$t('global.after')
                }
            ]
        }
    },
    methods: {
        search(){
			this.showAlertFilter = (this.filtersClean.transportServiceId>0)?true:false;
			this.$root.$emit('bv::refresh::table', 'table-history')
		}
    },
    computed: {
        filtersClean(){
			return {
				id:  this.modelId,
				transportServiceId:this.filters.transportServiceId
			}
		},
		optsRides(){
			let rides = [{value: "", text: 'Todos' }];
			this.model.transportServices.forEach((ts)=>{
				if(ts.id>0){
					rides.push({value:ts.id,text:ts.serviceNumber})
				}
			})
			return rides;
		}
    }
}
</script>